import React, { useEffect, useState } from "react";

import VisibilityIcon from "@mui/icons-material/Visibility";
import RedoIcon from '@mui/icons-material/Redo';
import ModeEditIcon from "@mui/icons-material/ModeEdit";

import DeleteIcon from "@mui/icons-material/Delete";

import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Box,
  Select,
  MenuItem,
  SelectChangeEvent,
  Typography,
  Tabs,
  Tab,
  Popper,
  ClickAwayListener,
  Paper,
  Chip,
  TextField,
  InputAdornment,
  Tooltip,
  Checkbox,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import SearchBar2 from "../../components/SearchBar2";
import { isValidInput } from "../../utils/validation";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody, CompanyRequest } from "../../types/General";
import { errorToast, successToast, warnToast } from "../../helpers/toast";
import Pagination from "../../components/Pagination";

import Loader from "../../helpers/constants/Loader";

import ReasonModal from "../../components/RejectReason";
import moment from "moment";
import { DayPicker } from "react-day-picker";
import { Clear } from "@mui/icons-material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";


import { useLazyGetPropertyVerificationQuery, useVerifyMultiplePropertyMutation, useVerifyPropertyMutation } from "../../services/propertyListing";
import { PROPERTY_VERIFICATION_STATUS } from "../../constants/enums";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const PropertyVerification = () => {
  const navigate = useNavigate();



  const [selectAll, setSelectAll] = useState(false);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [open, setOpen] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<string>("");
  const [fetchVerifications] = useLazyGetPropertyVerificationQuery();
  const [limit, setLimit] = useState<number>(10);
  const [reason, setReason] = useState<string>("");

  const [request, setRequest] = useState<CompanyRequest[]>([]);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [editCompanybyId] = useVerifyPropertyMutation();
  const [verifyMultipleApi] = useVerifyMultiplePropertyMutation();
  let totalPages = Math.ceil(totalCount / limit);
  const onPageChange = (newPage: number) => {
    setPage(newPage);
  };

  const [value, setValue] = React.useState(0);

  const [dataCount, setDataCount] = useState({
    pendingRequests: 0,
    aproovedRequests: 0,
    rejectedRequests: 0,
  });

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setPage(1);
  };
  const [selectedRows, setSelectedRows] = useState<string[]>([]);

  const [open1, setOpen1] = useState(false); // Control calendar visibility
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [selectedChip, setSelectedChip] = useState("");
  const [month, setMonth] = useState(new Date());
  const [range, setRange] = useState<{
    from: Date | undefined;
    to: Date | undefined;
  }>({
    from: undefined,
    to: undefined,
  });


  function formatNumberWithCommas(value: string | number) {
    const valueStr = typeof value === 'number' ? value.toFixed(2) : value;
    const [integer, decimal] = valueStr.split('.');
    const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    let result = decimal !== undefined ? `${formattedInteger}.${decimal}` : formattedInteger;
    return result;
  }

  const fetchData = async () => {
    setIsLoading(true)
    try {
      const res = await fetchVerifications({
        status: value + 1, page: page, limit: limit, startDate: range?.from ? moment(range?.from).startOf("day").format("YYYY-MM-DDTHH:mm:ss[Z]") : "",
        endDate: range?.to ? moment(range?.to).endOf('day').format("YYYY-MM-DDTHH:mm:ss[Z]") : "",
        search: debouncedSearchTerm
      }).unwrap();
      if (res?.statusCode === 200) {
        setRequest(res?.data?.rows || []);
        setTotalCount(res?.data?.count);
        setDataCount({
          pendingRequests: res?.data?.pendingRequests || 0,
          aproovedRequests: res?.data?.approvedRequests || 0,
          rejectedRequests: res?.data?.rejectedRequests || 0,
        })
      }
      setIsLoading(false)
    } catch (error: any) {
      setIsLoading(false)
      errorToast(error?.message || error?.data?.message)
    }
  }


  const handleClose = () => {
    setOpen1(false);
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen1(true);
  };

  const getFormattedRange = () => {
    if (range?.from && range?.to) {
      return `${moment(range.from).format("MM/DD/YYYY")} - ${moment(
        range.to
      ).format("MM/DD/YYYY")}`;
    } else if (range?.from) {
      return moment(range.from).format("MM/DD/YYYY");
    }
    return "";
  };

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectAll(event.target.checked);
    setSelectedRows(
      event.target.checked ? request?.map((r: any) => r._id) : []
    );
  };


  const handleRowCheckboxClick = (
    event: React.ChangeEvent<HTMLInputElement>,
    rowId: string
  ) => {
    if (event.target.checked) {
      setSelectedRows((prevSelected) => [...prevSelected, rowId]);
    } else {
      setSelectedRows((prevSelected) =>
        prevSelected.filter((id) => id !== rowId)
      );
    }
  };

  const handleSelect = (selectedRange: any) => {
    if (selectedRange === undefined) {
      setRange({ from: undefined, to: undefined });
    } else {
      setRange(selectedRange);
    }
  };

  const handleChipClick = (value: any) => {
    if (value === selectedChip) {
      setSelectedChip("");
      setRange({ from: undefined, to: undefined });
      setMonth(moment().toDate());
      return;
    }
    setSelectedChip(value);

    let newRange = { from: moment().toDate(), to: moment().toDate() };
    const today = moment();

    if (value === "lastMonth") {
      newRange = {
        from: moment().subtract(1, "months").startOf("month").toDate(),
        to: moment().subtract(1, "months").endOf("month").toDate(),
      };
    } else if (value === "lastWeek") {
      newRange = {
        from: moment().subtract(7, "days").startOf("day").toDate(),
        to: today.toDate(),
      };
    } else if (value === "lastYear") {
      newRange = {
        from: moment().subtract(1, "years").startOf("year").toDate(),
        to: moment().subtract(1, "years").endOf("year").toDate(),
      };
    }
    setRange(newRange);
    setMonth(newRange.from);
  };

  const handleMonthChange = (newMonth: any) => {
    setMonth(newMonth);
  };

  const [receiverStates, setReceiverStates] = useState<{
    [key: string]: string;
  }>({});

  const handleReceiverChange = async (
    event: SelectChangeEvent,
    userId: string
  ) => {
    const newValue = event.target.value;

    // Update the receiver state for the specific row
    setReceiverStates((prevState) => ({
      ...prevState,
      [userId]: newValue,
    }));

    const body = {
      verificationRequestStatus: Number(newValue),
      propertyIds: [userId]
    };

    if (Number(newValue) === 2) {
      try {
        setIsLoading(true);
        let encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
        const response = await verifyMultipleApi(
          encryptedBody,

        ).unwrap();
        if (response?.statusCode === 200) {
          setIsLoading(false);
          setValue(1);

          successToast("Request Approved successfully");
        }
      } catch (error: any) {
        setIsLoading(false);
        errorToast(error?.data?.message || "");
      }
    } else {
      setReceiverStates((prevState) => ({
        ...prevState,
        [userId]: "3",
      }));
      setOpen(true);
    }
  };

  const handleMultipleVerify = async () => {


    const body = {
      verificationRequestStatus: PROPERTY_VERIFICATION_STATUS.APPROVED,
      propertyIds: selectedRows
    };
    console.log(body, "body");


    try {
      setIsLoading(true);
      let encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await verifyMultipleApi(
        encryptedBody
      ).unwrap();
      if (response?.statusCode === 200) {
        setIsLoading(false);
        setValue(1);

        successToast("Request Approved successfully");
      }
    } catch (error: any) {
      setIsLoading(false);
      errorToast(error?.data?.message || "");
    }

  };

  const handleReject = async () => {
    if (!selectedId || Number(receiverStates[selectedId]) !== 3) {
      return;
    }

    const body = {
      verificationRequestStatus: PROPERTY_VERIFICATION_STATUS.REJECT,
      rejectionReason: reason,
      propertyIds: [selectedId]
    };

    try {
      setIsLoading(true);

      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await verifyMultipleApi(
         encryptedBody,
        
      ).unwrap();

      if (response?.statusCode === 200) {
        setIsLoading(false);
        setValue(2);

        successToast("Request rejected successfully");

        // Optionally reset the state for the row after rejection
        setReceiverStates((prev) => ({ ...prev, [selectedId]: "1" })); // Reset receiver to Pending or default value
      }
    } catch (error: any) {
      setIsLoading(false);
      errorToast(error?.data?.message || "");
    }
  };



  useEffect(() => {
    fetchData()
  }, [value, page, limit, range, debouncedSearchTerm])


  return (
    <div>
      <Loader isLoad={isLoading} />
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">Manage Property verification Requests</h1>
        </div>
        <Card className="cards">
          <Box className="custom_tabs">
            <Box className="cards_header">
              <Box className="cards_header_left">
                <SearchBar2
                  value={searchTerm}
                  searchTerm={searchTerm}
                  onCross={() => setSearchTerm("")}
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                      setTimeout(() => {
                        setPage(1)
                      }, 1000)
                    }
                  }}
                />
                <div className="control_group" style={{ width: "250px" }}>
                  <TextField
                    // label="Select Date Range"
                    variant="outlined"
                    hiddenLabel
                    className="text_field-range"
                    fullWidth
                    onClick={handleClick}
                    value={getFormattedRange()}
                    placeholder="Select Date Range"
                    InputProps={{
                      readOnly: true,
                      endAdornment: range?.from ? (
                        <InputAdornment
                          position="end"
                          style={{ marginLeft: -50 }}
                        >
                          <IconButton
                            onClick={() => {
                              setRange({
                                from: undefined,
                                to: undefined,
                              });
                            }}
                          >
                            <Clear />
                          </IconButton>
                        </InputAdornment>
                      ) : (
                        <InputAdornment position="end">
                          <IconButton>
                            <CalendarTodayIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                <Popper
                  open={open1}
                  anchorEl={anchorEl}
                  placement="bottom-start"
                  disablePortal
                  style={{
                    position: "relative",
                    zIndex: 1,
                  }}
                >
                  <ClickAwayListener onClickAway={handleClose}>
                    <Paper
                      elevation={3}
                      style={{ position: "relative", zIndex: 1 }}
                    >
                      <div
                        style={{
                          padding: 8,
                          borderRadius: 10,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-around",
                            padding: "8px",
                          }}
                        >
                          <Chip
                            label="Last Week"
                            variant={
                              selectedChip === "lastWeek"
                                ? "filled"
                                : "outlined"
                            }
                            onClick={() => handleChipClick("lastWeek")}
                          />
                          <Chip
                            label="Last Month"
                            variant={
                              selectedChip === "lastMonth"
                                ? "filled"
                                : "outlined"
                            }
                            onClick={() => handleChipClick("lastMonth")}
                          />
                          <Chip
                            label="Last Year"
                            variant={
                              selectedChip === "lastYear"
                                ? "filled"
                                : "outlined"
                            }
                            onClick={() => handleChipClick("lastYear")}
                          />
                        </div>

                        <DayPicker
                          className="react-day-picker"
                          mode="range"
                          selected={range}
                          onSelect={handleSelect}
                          // numberOfMonths={10}
                          month={month}
                          onMonthChange={handleMonthChange}
                        // styles={{
                        //   months: { display: "flex", gap: "16px" },
                        //   month: { margin: 0 },
                        // }}
                        />
                      </div>
                    </Paper>
                  </ClickAwayListener>
                </Popper>
              </Box>
            </Box>
            <Tabs
              style={{ marginTop: "20px" }}
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab
                label={`Pending (${dataCount?.pendingRequests})`}
                {...a11yProps(0)}
              />
              <Tab
                label={`Approved (${dataCount?.aproovedRequests})`}
                {...a11yProps(1)}
              />
              <Tab
                label={`Rejected (${dataCount?.rejectedRequests})`}
                {...a11yProps(2)}
              />
            </Tabs>
            <CustomTabPanel value={value} index={0}>
              {selectedRows?.length ? (
                <Button className="btn btn_primary" onClick={() => handleMultipleVerify()} >
                  Verify properties
                </Button>
              ) : ("")}

              <TableContainer className="table_container">
                <Box className="heading"></Box>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <Checkbox
                          checked={selectAll}
                          onChange={handleSelectAllClick}
                          inputProps={{ "aria-label": "select all rows" }}
                        />
                      </TableCell>
                      <TableCell align="center">S.No</TableCell>
                      <TableCell align="center">Actions</TableCell>
                      <TableCell>Property Id</TableCell>
                      <TableCell>Badges</TableCell>
                      <TableCell>Reference No.</TableCell>
                      <TableCell>Image</TableCell>
                      <TableCell>Property Name</TableCell>
                      <TableCell>Price</TableCell>
                      <TableCell>Company Name</TableCell>
                      <TableCell>Agent Name</TableCell>
                      <TableCell>Listing Type</TableCell>
                      <TableCell>Boost Property</TableCell>
                      <TableCell>Property Category</TableCell>
                      <TableCell>Property Type</TableCell>
                      <TableCell>Quality Score</TableCell>
                      {/* <TableCell>Date & time</TableCell> */}
                      <TableCell>Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {request?.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={9} align="center">
                          No  request found
                        </TableCell>
                      </TableRow>
                    ) : (
                      request?.map((row: any, i: any) => (
                        <TableRow key={i}>
                          <TableCell>
                            <Checkbox
                              checked={selectedRows.includes(row?._id)}
                              onChange={(event) =>
                                handleRowCheckboxClick(event, row?._id)
                              }
                            />
                          </TableCell>
                          <TableCell align="center">
                            {(page - 1) * 10 + i + 1}
                          </TableCell>
                          <TableCell align="center">
                            <Box className="table_actions">
                              <Tooltip title="View company details">
                                <IconButton
                                  onClick={() =>
                                    navigate(
                                      `/property-verification-details/${row?._id}`
                                    )
                                  }
                                >
                                  <VisibilityIcon />
                                </IconButton>
                              </Tooltip>


                            </Box>
                          </TableCell>
                          <TableCell>{row?.referenceId || "-"}</TableCell>
                          <TableCell align="center">
                            <figure
                              className="user_img"
                            >

                              {row?.isVerified ? (
                                <img className="property_badge" src="/static/images/verfy_icon.svg" alt="" />
                              ) : ("")}
                              {row?.qualityScore >= 80 ? (
                                <img src="/static/images/verify_ico.svg" alt="" />
                              ) : ("")}
                              {row?.isPropertyBoost ? (
                                <img src="/static/images/boost.png" alt="" />
                              ) : ("")}

                            </figure>
                          </TableCell>
                          <TableCell>{row?.import_reference_number || "-"}</TableCell>
                          <TableCell>
                            <figure
                              className="user_img"
                              onClick={() =>
                                navigate(
                                  `/property-verification-details/${row?._id}`
                                )
                              }
                            >
                              <img
                                style={{ borderRadius: 0 }}
                                src={
                                  row?.images?.[0] ? row?.images?.[0] : row?.interior?.[0] ? row?.interior?.[0] :
                                    `/static/images/product1.png`
                                }
                                alt=""
                              />
                            </figure>
                          </TableCell>
                          <TableCell style={{ minWidth: "220px", textWrap: "wrap" }} >{row?.name || "-"}</TableCell>
                          <TableCell>
                            {row?.price
                              ? formatNumberWithCommas(String(row?.price))
                              : "-"}
                          </TableCell>
                          <TableCell>{row?.companyId?.companyName ? row?.companyId?.companyName + " (" + row?.companyId?.referenceId + ")" : "-"}</TableCell>
                          <TableCell>{row?.userId?.role === 5 || !row?.userId?.role ? "-" : row?.userId?.name + " (" + row?.userId?.referenceId + ")" || "-"}</TableCell>
                          <TableCell>{row?.listingType === 1 ? "STANDARD" : row?.listingType === 2 ? "FEATURED" : row?.listingType === 3 ? "PREMIUM" : "-"}</TableCell>
                          <TableCell>{row?.isPropertyBoost ? "Yes" : "No"}</TableCell>
                          <TableCell>{row?.category?.name || "-"}</TableCell>
                          <TableCell>
                            {row?.propertyTypes?.name || "-"}
                          </TableCell>
                          <TableCell>
                            {row?.qualityScore || "-"}
                          </TableCell>
                          {/* <TableCell>{row?.createdAt ? moment(row?.createdAt).format("LLL") : "-"}</TableCell> */}

                          <TableCell>

                            <Select
                              fullWidth
                              className="select_div reqst_Select"
                              labelId="demo-simple-select-label"
                              id={`demo-simple-select`}
                              value={receiverStates[row._id] || "1"}
                              inputProps={{
                                "aria-label": "Without label",
                              }}
                              displayEmpty
                              onChange={(e: any) => {

                                setSelectedId(row._id);
                                handleReceiverChange(e, row._id);

                              }}

                            >
                              <MenuItem value="1" disabled>
                                Pending
                              </MenuItem>
                              <MenuItem style={row?.qualityScore < 80 ? { color: "grey" } : {}}
                                value="2">Verify</MenuItem>
                              <MenuItem value="3">Reject</MenuItem>
                            </Select>
                          </TableCell>

                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              {request?.length > 0 ? (
                <Pagination
                  setPage={setPage}
                  limit={limit}
                  setLimit={setLimit}
                  module={request}
                  page={page}
                  onPageChange={onPageChange}
                  totalPages={totalPages}
                />
              ) : (
                ""
              )}

            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <TableContainer className="table_container">
                <Box className="heading"></Box>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">S.No</TableCell>
                      <TableCell align="center">Actions</TableCell>
                      <TableCell>Property Id</TableCell>
                      <TableCell>Badges</TableCell>
                      <TableCell>Reference No.</TableCell>
                      <TableCell>Image</TableCell>
                      <TableCell>Property Name</TableCell>
                      <TableCell>Price</TableCell>
                      <TableCell>Company Name</TableCell>
                      <TableCell>Agent Name</TableCell>
                      <TableCell>Listing Type</TableCell>
                      <TableCell>Boost Property</TableCell>
                      <TableCell>Property Category</TableCell>
                      <TableCell>Property Type</TableCell>
                      <TableCell>Quality Score</TableCell>
                      {/* <TableCell>Date & time</TableCell> */}


                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {request?.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={9} align="center">
                          No  request found
                        </TableCell>
                      </TableRow>
                    ) : (
                      request?.map((row: any, i: any) => (
                        <TableRow key={i}>
                          <TableCell align="center">
                            {(page - 1) * 10 + i + 1}
                          </TableCell>
                          <TableCell>
                            <Box className="table_actions">
                              <Tooltip title="View company details">
                                <IconButton
                                  onClick={() =>
                                    navigate(
                                      `/property-verification-details/${row?._id}`
                                    )
                                  }
                                >
                                  <VisibilityIcon />
                                </IconButton>
                              </Tooltip>


                            </Box>
                          </TableCell>
                          <TableCell>{row?.referenceId || "-"}</TableCell>
                          <TableCell align="center">
                            <figure
                              className="user_img"
                            >

                              {row?.isVerified ? (
                                <img className="property_badge" src="/static/images/verfy_icon.svg" alt="" />
                              ) : ("")}
                              {row?.qualityScore >= 80 ? (
                                <img src="/static/images/verify_ico.svg" alt="" />
                              ) : ("")}
                              {row?.isPropertyBoost ? (
                                <img src="/static/images/boost.png" alt="" />
                              ) : ("")}

                            </figure>
                          </TableCell>
                          <TableCell>{row?.import_reference_number || "-"}</TableCell>
                          <TableCell>
                            <figure
                              className="user_img"
                              onClick={() =>
                                navigate(
                                  `/property-verification-details/${row?._id}`
                                )
                              }
                            >
                              <img
                                style={{ borderRadius: 0 }}
                                src={
                                  row?.images?.[0] ? row?.images?.[0] : row?.interior?.[0] ? row?.interior?.[0] :
                                    `/static/images/product1.png`
                                }
                                alt=""
                              />
                            </figure>
                          </TableCell>
                          <TableCell style={{ minWidth: "220px", textWrap: "wrap" }} >{row?.name || "-"}</TableCell>
                          <TableCell>
                            {row?.price
                              ? formatNumberWithCommas(String(row?.price))
                              : "-"}
                          </TableCell>
                          <TableCell>{row?.companyId?.companyName ? row?.companyId?.companyName + " (" + row?.companyId?.referenceId + ")" : "-"}</TableCell>
                          <TableCell>{row?.userId?.role === 5 || !row?.userId?.role ? "-" : row?.userId?.name + " (" + row?.userId?.referenceId + ")" || "-"}</TableCell>
                          <TableCell>{row?.listingType === 1 ? "STANDARD" : row?.listingType === 2 ? "FEATURED" : row?.listingType === 3 ? "PREMIUM" : "-"}</TableCell>
                          <TableCell>{row?.isPropertyBoost ? "Yes" : "No"}</TableCell>
                          <TableCell>{row?.category?.name || "-"}</TableCell>
                          <TableCell>
                            {row?.propertyTypes?.name || "-"}
                          </TableCell>
                          <TableCell>{row?.qualityScore || "-"}</TableCell>
                          {/* <TableCell>{row?.createdAt ? moment(row?.createdAt).format("LLL") : "-"}</TableCell> */}



                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              {request?.length ? (
                <Pagination
                  setPage={setPage}
                  limit={limit}
                  setLimit={setLimit}
                  module={request}
                  page={page}
                  onPageChange={onPageChange}
                  totalPages={totalPages}
                />
              ) : (
                ""
              )}

            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <TableContainer className="table_container">
                <Box className="heading"></Box>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">S.No</TableCell>
                      <TableCell align="center">Actions</TableCell>
                      <TableCell>Property Id</TableCell>
                      <TableCell>Badges</TableCell>
                      <TableCell>Reference No.</TableCell>
                      <TableCell>Image</TableCell>
                      <TableCell>Property Name</TableCell>
                      <TableCell>Price</TableCell>
                      <TableCell>Company Name</TableCell>
                      <TableCell>Agent Name</TableCell>
                      <TableCell>Listing Type</TableCell>
                      <TableCell>Boost Property</TableCell>
                      <TableCell>Property Category</TableCell>
                      <TableCell>Property Type</TableCell>
                      <TableCell>Quality Score</TableCell>
                      <TableCell>Reject Reason</TableCell>
                      {/* <TableCell>Date & time</TableCell> */}

                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {request?.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={9} align="center">
                          No  request found
                        </TableCell>
                      </TableRow>
                    ) : (
                      request?.map((row: any, i: any) => (
                        <TableRow key={i}>
                          <TableCell align="center">
                            {(page - 1) * 10 + i + 1}
                          </TableCell>
                          <TableCell>
                            <Box className="table_actions">
                              <Tooltip title="View company details">
                                <IconButton
                                  onClick={() =>
                                    navigate(
                                      `/property-verification-details/${row?._id}`
                                    )
                                  }
                                >
                                  <VisibilityIcon />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          </TableCell>
                          <TableCell>{row?.referenceId || "-"}</TableCell>
                          <TableCell align="center">
                            <figure
                              className="user_img"
                            >

                              {row?.isVerified ? (
                                <img className="property_badge" src="/static/images/verfy_icon.svg" alt="" />
                              ) : ("")}
                              {row?.qualityScore >= 80 ? (
                                <img src="/static/images/verify_ico.svg" alt="" />
                              ) : ("")}
                              {row?.isPropertyBoost ? (
                                <img src="/static/images/boost.png" alt="" />
                              ) : ("")}

                            </figure>
                          </TableCell>
                          <TableCell>{row?.import_reference_number || "-"}</TableCell>
                          <TableCell>
                            <figure
                              className="user_img"
                              onClick={() =>
                                navigate(
                                  `/property-verification-details/${row?._id}`
                                )
                              }
                            >
                              <img
                                style={{ borderRadius: 0 }}
                                src={
                                  row?.images?.[0] ? row?.images?.[0] : row?.interior?.[0] ? row?.interior?.[0] :
                                    `/static/images/product1.png`
                                }
                                alt=""
                              />
                            </figure>
                          </TableCell>
                          <TableCell style={{ minWidth: "220px", textWrap: "wrap" }} >{row?.name || "-"}</TableCell>
                          <TableCell>
                            {row?.price
                              ? formatNumberWithCommas(String(row?.price))
                              : "-"}
                          </TableCell>
                          <TableCell>{row?.companyId?.companyName ? row?.companyId?.companyName + " (" + row?.companyId?.referenceId + ")" : "-"}</TableCell>
                          <TableCell>{row?.userId?.role === 5 || !row?.userId?.role ? "-" : row?.userId?.name + " (" + row?.userId?.referenceId + ")" || "-"}</TableCell>
                          <TableCell>{row?.listingType === 1 ? "STANDARD" : row?.listingType === 2 ? "FEATURED" : row?.listingType === 3 ? "PREMIUM" : "-"}</TableCell>
                          <TableCell>{row?.isPropertyBoost ? "Yes" : "No"}</TableCell>
                          <TableCell>{row?.category?.name || "-"}</TableCell>
                          <TableCell>
                            {row?.propertyTypes?.name || "-"}
                          </TableCell>
                          <TableCell>{row?.qualityScore || "-"}</TableCell>
                          <TableCell style={{ minWidth: "220px", textWrap: "wrap" }}> {row?.rejectionReason || ""}</TableCell>
                          {/* <TableCell>{row?.createdAt ? moment(row?.createdAt).format("LLL") : "-"}</TableCell> */}



                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              {request?.length > 0 ? (
                <Pagination
                  setPage={setPage}
                  limit={limit}
                  setLimit={setLimit}
                  module={request}
                  page={page}
                  onPageChange={onPageChange}
                  totalPages={totalPages}
                />
              ) : (
                ""
              )}

            </CustomTabPanel>
          </Box>
        </Card>
      </div>
      <ReasonModal
        open={open}
        setOpen={setOpen}
        handleDelete={handleReject}
        reason={reason}
        setReason={setReason}
      />
    </div >
  );
};

export default PropertyVerification;
